"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ACTIVITY_DETAILS: 'ACTIVITY_DETAILS',
    DIRECTORY_AND_OFFER_DETAILS: 'DIRECTORY_AND_OFFER_DETAILS',
    BOOKING_DETAILS: 'BOOKING_DETAILS',
    CONTACT: 'CONTACT',
    CONVENTION: 'CONVENTION',
    SEARCH: 'SEARCH',
    CHAT_INTRO: 'CHAT_INTRO',
    TUI_CHAT_MODAL: 'TUI_CHAT_MODAL',
    NOTIFICATION_INSTRUCTIONS: 'NOTIFICATION_INSTRUCTIONS',
};
